// @ts-strict

import { Component, EventEmitter, Input, Output, OnChanges } from '@angular/core';
import { urlParameters } from '@app/core/helpers/constants';
@Component({
  selector: 'app-postback-url-parameters',
  templateUrl: './postback-url-parameters.component.html',
  styleUrls: ['./postback-url-parameters.component.scss']
})
export class PostbackUrlParametersComponent implements OnChanges {
  @Input() usedParameters: string[] = [];
  @Input() urlAddress: string = '';
  @Input() isUrlValid: boolean = false;

  @Output() parameter = new EventEmitter<string>();

  public readonly urlParameters = urlParameters;

  ngOnChanges(): void {
    if (this.urlAddress) {
      const parameters = this.urlAddress.replace('?', '').split('&');

      if (parameters.length) {
        this.urlParameters.forEach(urlParam => {
          if (parameters.includes(`[${urlParam}]`) && !this.usedParameters.includes(urlParam)) {
            this.usedParameters.push(urlParam);
          } else if (this.usedParameters.includes(urlParam)) {
            this.usedParameters = this.usedParameters.filter(parameter => parameter !== urlParam);
          }
        });
      }
    }
  }

  public isParamUsed(param: string): boolean {
    return Boolean(this.urlAddress && this.urlAddress.includes(`[${param}]`));
  }

  public setParameter(parameter: string): void {
    this.parameter.emit(parameter);
  }
}
